import { render, staticRenderFns } from "./PurchaseInfoRecord.vue?vue&type=template&id=565dff94&"
import script from "./PurchaseInfoRecord.vue?vue&type=script&lang=js&"
export * from "./PurchaseInfoRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports